import React from "react"
import PropTypes from "prop-types"
import tw, { styled } from "twin.macro"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const Section = styled.section`
  ${tw`relative z-10 overflow-hidden bg-white py-c40 md:py-c60 px-offset md:px-offsetMd xl:px-24`}
`
const Wrapper = styled.div`
  ${tw`relative z-10 pt-c300 lg:py-c120 rounded-[30px] overflow-hidden`}
  box-shadow: 10px 10px 50px 0px rgba(0, 0, 255, 0.10);
`

const WpAcfHighlightTeaserModuleBlock = ({ moduleData }) => {
  const { backgroundImage, heading, description } =
    moduleData.acfHighlightTeaser || {}

  return (
    <Section>
      <Wrapper>
        <div className="absolute top-0 left-0 right-0 w-full h-full background-image rounded-[30px] overflow-hidden">
          <GatsbyImage
            image={getImage(backgroundImage?.localFile)}
            alt={backgroundImage?.altText || ""}
            className="object-cover w-full h-1/2 lg:h-full"
          />
        </div>
        <div className="content bg-white rounded-b-[30px] p-c30 md:p-c40 lg:p-c60 lg:mx-c80 w-full lg:max-w-2xl lg:rounded-[30px] relative z-10">
          <h2 className="font-bold text-black text-32 sm:text-40 font-ubuntu mb-c30">
            {heading}
          </h2>
          <p className="text-black text-20 font-firacode">{description}</p>
        </div>
      </Wrapper>
    </Section>
  )
}

WpAcfHighlightTeaserModuleBlock.propTypes = {
  moduleData: PropTypes.object,
}

WpAcfHighlightTeaserModuleBlock.defaultProps = {
  moduleData: {},
}

export default WpAcfHighlightTeaserModuleBlock
